import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { storageOverusedError } from "~/store/actions/actions.httpMessages.jsx";
import { StorageOverusedError } from "~/utils/errors/index.js";
import { useFileTokenContext } from "../FilePreview/index.jsx";
import useTinyMCEAutocomplete from "../Hooks/useTinyMCEAutocomplete.jsx";
import { showErrorToast } from "../Toast/index.js";
import VisualEditor from "../VisualEditor/VisualEditor.jsx";

const VisualEditorContainer = ({
  projectId,
  parentType,
  parentId,
  content,
  bodyMode,
  onChange,
  directionality,
  placeholder,
  onKeyDown,
  autoFocus,
  showTextVariables,
}) => {
  const { preview_token, download_token, thumb_token } = useFileTokenContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const autocompleteConfig = useTinyMCEAutocomplete({
    projectId,
    parentType,
    parentId,
    hideProject: projectId === 0,
  });

  const onFileUploadFailed = useCallback(
    (error) => {
      if (error instanceof StorageOverusedError) {
        dispatch(storageOverusedError(error));
      } else {
        showErrorToast(`${t("Upload failed")}.`);
      }
    },
    [dispatch, t]
  );

  content = content
    .replace(/--PREVIEW-TOKEN--/g, preview_token)
    .replace(/--THUMBNAIL-TOKEN--/g, thumb_token)
    .replace(/--DOWNLOAD-TOKEN--/g, download_token);

  return (
    <VisualEditor
      autocompleteConfig={autocompleteConfig}
      content={content}
      bodyMode={bodyMode}
      onChange={onChange}
      directionality={directionality}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
      onFileUploadFailed={onFileUploadFailed}
      showTextVariables={showTextVariables}
    />
  );
};

VisualEditorContainer.propTypes = {
  projectId: PropTypes.number,
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  content: PropTypes.string,
  bodyMode: PropTypes.string,
  onChange: PropTypes.func,
  directionality: PropTypes.string,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  showTextVariables: PropTypes.bool,
};

export default VisualEditorContainer;
